import React from 'react';
import PropTypes from 'prop-types';

import utilService from '../../../../services/UtilService';

class ResponsesInfo extends React.Component {
    static propTypes = {
        alternatives: PropTypes.array.isRequired,
        correctResponses: PropTypes.array,
        showAllAlternatives: PropTypes.bool,
    };

    static getAlternativesList(alternatives, correctResponses = []) {
        const correctIdentifier = correctResponses.length > -1 ? correctResponses[0] : '';

        const alternativesList = alternatives.map((alternative) => {
            const className = alternative.identifier === correctIdentifier ? 'inline-correct-text' : 'inline-text';
            return (<span className={className} key={alternative.identifier}>{alternative.content}</span>);
        });

        return utilService.intersperse(alternativesList, ', ');
    }

    static getCorrectAlternative(alternatives, correctResponses = []) {
        const correctIdentifier = correctResponses.length > -1 ? correctResponses[0] : '';
        const correctAlternative = alternatives.find(alternative => alternative.identifier === correctIdentifier);

        if (!correctAlternative) {
            return null;
        }

        return (<span className="inline-correct-text">({correctAlternative.content})</span>);
    }

    render() {
        const { alternatives, correctResponses, showAllAlternatives } = this.props;

        if (!showAllAlternatives) {
            return ResponsesInfo.getCorrectAlternative(alternatives, correctResponses);
        }

        return (
            <span>
                ({ResponsesInfo.getAlternativesList(alternatives, correctResponses)})
            </span>
        );
    }
}

export default ResponsesInfo;
